<h2 lvrPadding [padHorizontal]="32" [padVertical]="0" id="client-career-heading">
	{{ 'client.career.create_title' | transloco }}
</h2>
<form
	[formGroup]="form"
	lvrAutoSave="career"
	[entityId]="draftId"
	[autoLoad]="false"
	aria-labelledby="client-career-heading"
>
	<lvr-section>
		<lvr-section-form>
			<!-- Date Field -->
			<lvr-field
				[label]="'client.career.date' | transloco | appendAsterisk"
				[matTooltip]="'client.career.date_hint' | transloco"
			>
				@let dateCtrl = form.get('date');
				<mat-form-field
					lvrInput
					[lvrError]="hasError(dateCtrl, 'required', 'maxDateExceeded', 'minDateExceeded', 'alreadyExisting')"
				>
					<input
						matInput
						formControlName="date"
						[matDatepicker]="picker"
						placeholder="10.10.2025"
						[min]="minMaxDate.min"
						[max]="minMaxDate.max"
						[errorStateMatcher]="matcher"
					/>
					@if (hasError(dateCtrl, 'required')) {
						<mat-error>{{ 'client.career.error.required' | transloco }}</mat-error>
					}
					@if (hasError(dateCtrl, 'minDateExceeded')) {
						<mat-error>{{ 'client.career.error.minDateExceeded' | transloco: { min: minMaxDate.minYears } }}</mat-error>
					}
					@if (hasError(dateCtrl, 'maxDateExceeded')) {
						<mat-error>{{ 'client.career.error.maxDateExceeded' | transloco: { max: minMaxDate.maxYears } }}</mat-error>
					}
					@if (hasError(dateCtrl, 'alreadyExisting')) {
						<mat-error>{{ 'client.career.error.already_existing' | transloco }}</mat-error>
					}
					<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
				</mat-form-field>
			</lvr-field>

			<!-- Remark Field (Freitextfeld für den Beginn der Beschäftigung fals Datum nicht genau) -->
			<lvr-field [label]="'client.career.remark' | transloco">
				<mat-form-field lvrInput>
					<input
						matInput
						formControlName="remarkOfTheCareerStage"
						[placeholder]="'client.career.remark_placeholder' | transloco"
					/>
					<mat-hint>{{ 'client.career.remark_hint' | transloco }}</mat-hint>
				</mat-form-field>
			</lvr-field>

			<!-- Social Security Status (Sozialrechtlicher Status) Field -->
			@let socialSecurityStatusCtrl = form.get('socialSecurityStatusId');
			<lvr-field [label]="'client.career.socialSecurityStatus' | transloco | appendAsterisk">
				<lvr-searchable-select
					formControlName="socialSecurityStatusId"
					[options]="socialSecurityStatusOptions()"
					[placeholder]="'base.field.select_please' | transloco | appendAsterisk"
					[searchPlaceholder]="'base.field.search_placeholder' | transloco"
					[noResultsText]="'base.field.no_results' | transloco"
					[required]="true"
					[hasError]="hasError(socialSecurityStatusCtrl, 'required')"
					[errorMessage]="'client.career.error.required' | transloco"
				></lvr-searchable-select>
			</lvr-field>
		</lvr-section-form>

		<!-- Sozialrechtlicher Status: J -->
		@switch (selectedSocialSecurityStatus()?.statusActivity) {
			@case (StatusActivity.J) {
				<lvr-social-security-status-full
					formControlName="additionalFields"
					[statusType]="StatusActivity.J"
				></lvr-social-security-status-full>
			}
			@case (StatusActivity.j) {
				<lvr-social-security-status-full
					formControlName="additionalFields"
					[statusType]="StatusActivity.j"
				></lvr-social-security-status-full>
			}
			@case (StatusActivity.N) {
				<lvr-social-security-status-minimal formControlName="additionalFields"></lvr-social-security-status-minimal>
			}
			@case (StatusActivity.UNKNOWN) {
				<lvr-social-security-status-minimal formControlName="additionalFields"></lvr-social-security-status-minimal>
			}
			@case (StatusActivity.S) {
				<lvr-social-security-status-school formControlName="additionalFields"></lvr-social-security-status-school>
			}
		}
		<p class="required-hint" lvrPadding [padHorizontal]="0" [padVertical]="16">
			{{ 'base.form.required' | transloco }}
		</p>

		<lvr-default-actions
			[disableSave]="form.invalid || !canCreateCareersPermission()"
			[showLoading]="isLoading()"
			(save)="save()"
			(cancelSave)="cancel()"
		>
			<lvr-restore-actions entityType="career" [entityId]="draftId"></lvr-restore-actions>
		</lvr-default-actions>
	</lvr-section>
</form>
